import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import headerImg from '../images/header.png';
import stampImg from '../images/stamp-removebg-preview.png';
import watermarkImg from '../images/logo-rr-news.png';
import { getLetterUniqueId } from './reporterIdFormat';

export const generateConsentLetterPDF = async (formData, userName, reporterRole = 'CORRESPONDENT', reporterId = null, reporterRegion = null, approvedAt = null) => {
  try {
    // Use DB-stored reporterId as the primary unique ID source.
    const now = new Date();
    const uniqueId = getLetterUniqueId(reporterId, now);
    
    // Calculate validity dates - use approvedAt if provided, otherwise current date
    const fromDate = approvedAt ? new Date(approvedAt) : new Date();
    const toDate = new Date(fromDate);
    toDate.setFullYear(toDate.getFullYear() + 1);
    
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                          'July', 'August', 'September', 'October', 'November', 'December'];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    };
    
    const validFrom = formatDate(fromDate);
    const validUpto = formatDate(toDate);

    // Create temporary container
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.left = '-9999px';
    container.style.top = '0';
    container.style.width = '210mm';
    container.style.height = '297mm';
    container.style.backgroundColor = 'white';
    container.style.padding = '0';
    container.style.margin = '0';
    container.style.fontFamily = 'Arial, sans-serif';
    
    // Create the letter HTML
    container.innerHTML = `
      <div style="
        width: 100%;
        height: 100%;
        padding: 15px 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        position: relative;
        font-family: Arial, sans-serif;
        overflow: hidden;
      ">
        <!-- Watermark Background -->
        <div style="
          position: absolute;
          top: 400px;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0.3;
          pointer-events: none;
        ">
          <img src="${watermarkImg}" alt="Watermark" style="
            width: 80%;
            height: 550px;
            object-fit: cover;
            margin-left: 10%;
            margin-top: 50px;
            object-position: center;  
            opacity: 0.2;
          "/>
        </div>
        <!-- Header -->
        <div style="margin-bottom: 6px; flex-shrink: 0; height: 200px; display: flex; align-items: center; position: relative; z-index: 2;">
          <img src="${headerImg}" alt="Header" style="
            width: 100%;
            height: 200px;
            max-height: 200px;
            object-fit: contain;
            border-bottom: 2px solid #1a5490;
          " />
        </div>

        <!-- Organization Info -->
        <div style="text-align: center; margin-bottom: 8px; flex-shrink: 0; position: relative; z-index: 2;">
          <h2 style="
            color: #1a5490;
            margin: 3px 0;
            font-size: 18px;
            font-weight: bold;
          ">RR NEWS TV FASTEST UPDATE</h2>
          <p style="
            color: #d32f2f;
            margin: 3px 0;
            font-size: 12px;
            font-weight: bold;
          ">REG: UDYAM-UP-59-0118348</p>
        </div>

        <!-- Title -->
        <div style="
          text-align: center;
          margin-bottom: 8px;
          padding: 6px 8px;
          background: #1a5490;
          flex-shrink: 0;
          position: relative;
          z-index: 2;
        ">
          <h1 style="
            color: #ffffff;
            font-size: 16px;
            margin-top: -20px;
            font-weight: bold;
            text-transform: uppercase;
            letter-spacing: 1px;
          ">APPOINTMENT LETTER</h1>
        </div>

        <!-- User Details - HIGHLIGHTED -->
        <div style="
          background: #e3f2fd;
          padding: 12px;
          margin-bottom: 12px;
          border-left: 5px solid #1a5490;
          border: 2px solid #1a5490;
          border-radius: 4px;
          flex-shrink: 0;
          position: relative;
          z-index: 2;
        ">
          <table style="width: 100%; border-collapse: collapse; font-size: 10px; line-height: 1.6;">
            <tr>
              <td style="padding: 4px 6px; width: 35%; font-weight: bold; color: #1a5490; background: #fff3e0;">Name (नाम):</td>
              <td style="padding: 4px 6px; color: #000; font-weight: bold; background: #f5f5f5;">${userName || formData.name || 'N/A'}</td>
            </tr>
            <tr>
              <td style="padding: 4px 6px; font-weight: bold; color: #1a5490; background: #fff3e0;">Father's Name (पिता का नाम):</td>
              <td style="padding: 4px 6px; color: #000; font-weight: bold; background: #f5f5f5;">${formData.fatherName || 'N/A'}</td>
            </tr>
            <tr>
              <td style="padding: 4px 6px; font-weight: bold; color: #1a5490; background: #fff3e0;">Address (पता):</td>
              <td style="padding: 4px 6px; color: #000; background: #f5f5f5;font-weight: bold;">${formData.address || 'N/A'}</td>
            </tr>
            <tr>
              <td style="padding: 4px 6px; font-weight: bold; color: #1a5490; background: #fff3e0;">Mobile (मोबाइल):</td>
              <td style="padding: 4px 6px; color: #000; font-weight: bold; background: #f5f5f5;">${formData.mobileNumber || 'N/A'}</td>
            </tr>
            <tr>
              <td style="padding: 4px 6px; font-weight: bold; color: #1a5490; background: #fff3e0;">Email (ई-मेल):</td>
              <td style="padding: 4px 6px; color: #000; background: #f5f5f5;font-weight: bold;">${formData.email || 'N/A'}</td>
            </tr>
          </table>
        </div>

        <!-- Subject -->
        <div style="margin-bottom: 10px; flex-shrink: 0; position: relative; z-index: 2;">
          <p style="
            margin: 0 0 4px 0;
            font-size: 13px;
            font-weight: bold;
            color: #000;
          ><strong>Sub-</strong> Appointment Letter Non-paid as a <strong>"${reporterRole}${reporterRegion ? ' (' + reporterRegion + ')' : ''}"</strong> of the RR NEWS TV FASTEST UPDATE (Electronic and Social Media) ID No. ${uniqueId}</p>
        </div>

        <!-- Letter Body -->
        <div style="margin-bottom: 8px; font-size: 13px; line-height: 1.6; color: #000; text-align: justify; flex-grow: 1; overflow-y: auto; position: relative; z-index: 2;">
          <p style="margin: 0 0 8px 0;"><strong>Sir,</strong></p>
          
          <p style="margin: 0 0 8px 0;">
            On Behalf of <strong>"RR NEWS TV FASTEST UPDATE"</strong>, I write to confirm your appointment as 
            <strong>"${reporterRole}${reporterRegion ? ' (' + reporterRegion + ')' : ''}"</strong> of <strong>RR NEWS TV FASTEST UPDATE</strong>, 
            (Hindi National News Channel) Electronic, Social &amp; Web Portal Media, with effect:
          </p>
          
          <div style="
            // background: #e8f4f8;
            padding: 8px 12px;
            margin: 5px 0;
            border-left: 4px solid #1a5490;
            border-radius: 3px;
          ">
            <p style="margin: 0 0 5px 0; font-size: 13px; font-weight: bold; color: #1a5490;">
              <strong>From:</strong> ${validFrom}
            </p>
            <p style="margin: 0; font-size: 13px; font-weight: bold; color: #1a5490;">
              <strong>To:</strong> ${validUpto}
            </p>
          </div>

          <p style="margin: 8px 0; font-size: 13px;">
            This appointment is made on the basis of terms and conditions as stipulated. Your responsibilities include 
            coverage of news from the assigned region, submission of accurate reports, and adherence to editorial guidelines.
          </p>
        </div>

        <!-- Copy To Section - AFTER VALIDITY -->
        <div style="
          margin: -10px 0 10px 0;
          padding-top: 4px;
          border-top: 2px solid #1a5490;
          font-size: 12px;
          color: #333;
          flex-shrink: 0;
          position: relative;
          z-index: 2;
        ">
          <p style="margin: 0 0 5px 0; font-weight: bold; font-size: 12px;">
            Copy: The Following Was Sent For Information Overview With Respect To The Officers.
          </p>
          <ul style="margin: 5px 0; padding-left: 20px; line-height: 1.4; font-size: 12px;">
            <li>D.M ${reporterRegion || 'Sambhal'}</li>
            <li>S.P ${reporterRegion || 'Sambhal'}</li>
            <li>D.I.O ${reporterRegion || 'Sambhal'}</li>
            <li>Bureau Head Uttar Pradesh</li>
          </ul>
        </div>

        <!-- Signature + Stamp aligned -->
        <div style="
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          margin: -10px 0 2px 0;
          flex-shrink: 0;
          gap: 0;
          position: relative;
          z-index: 2;
        ">
          <p style="margin: 0 0 6px 0; font-size: 13px; font-weight: normal; color: #000;">Your Sincerely,</p>
          <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 3px; justify-content: flex-end;">
            <div style="width: 85px; height: 85px; flex-shrink: 0;">
              <img src="${stampImg}" alt="Stamp" style="
                width: 85px;
                height: 85px;
                object-fit: contain;
              " />
            </div>
            <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 0; padding-left: 2px; padding-top: 5px;">
              <p style="margin: 0 0 0 0; font-size: 12px; font-weight: bold; color: #000;">Rinku Kumar</p>
              <p style="margin: 0; font-size: 10px; color: #333;">(Founder/Editor)</p>
              <p style="margin: 1px 0 0 0; font-size: 10px; font-weight: bold; color: #1a5490;">RR NEWS TV FASTEST UPDATE</p>
            </div>
          </div>
        </div>

        <!-- Note Section - AT BOTTOM -->
        <div style="
          background: #fff9e6;
          padding: 10px 12px;
          margin-top: 6px;
          border: 1px solid #ff9800;
          border-radius: 3px;
          flex-shrink: 0;
          position: relative;
          z-index: 2;
        ">
          <p style="margin: 0 0 6px 0; font-size: 12px; font-weight: bold; color: #d32f2f;">
            <strong>Note:</strong>
          </p>
          <p style="margin: 0; font-size: 12px; line-height: 1.4; color: #333; text-align: justify;">
            The terms & conditions of the appointment. This appointment will be automatically canceled, 
            if you are not doing work with "RR NEWS TV FASTEST UPDATE". We will send termination notice on your Email or Mobile Number. 
            After sending this termination message, you will be immediately disappointed of this post.
          </p>
        </div>
      </div>
    `;

    document.body.appendChild(container);

    // Wait for images to load
    await new Promise(resolve => setTimeout(resolve, 500));

    // Convert to canvas
    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      imageTimeout: 0,
    });

    document.body.removeChild(container);

    // Create PDF
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

    // Download PDF
    const fileName = `Appointment_Letter_${uniqueId}_${Date.now()}.pdf`;
    pdf.save(fileName);

    return {
      success: true,
      uniqueId,
      validFrom,
      validUpto,
      fileName,
    };
  } catch (error) {
    console.error('PDF generation error:', error);
    throw new Error('पत्र जनरेशन विफल: ' + error.message);
  }
};


